import moment from 'moment-timezone';
import storage from 'viralstyle-ui/src/storage';
import hateoas from 'viralstyle-ui/src/hateoas';
import requestService from 'viralstyle-ui/src/requestService';

import store from 'store';
import campaignsTransformer from './_campaigns-transformer';
import { statusEnum } from './_campaigns-enum';

class CampaignsApi {
  getCampaigns(collection, domainId) {
    let url = `${hateoas.url('client_campaign_search')}?page={page}&limit={limit}&filters[]=onsite&with_visits=1&sort=${collection.sortFilter}`;

    url = url.assignParams({ clientId: storage.get('client-hash'), page: collection.page, limit: collection.limit });

    switch (collection.type) {
      case 'promotable':
        url += '&filters[]=online';
        break;
      case 'store':
        url += '&filters[]=online';
        if (domainId) url += `&filters[]=whitelabel_domain:${domainId}`;
        break;
      case 'all':
        url += '&filters[]=status_not:DRAFT';

        if (collection.domainFilter && collection.domainFilter != -1) {
          url += `&filters[]=whitelabel_domain:${collection.domainFilter}`;
        }

        break;
      default:
        url += `&filters[]=${collection.type}`;
        break;
    }

    switch (collection.statusFilter) {
      case statusEnum.ACTIVE:
        url += '&filters[]=ACTIVE';
        break;
      case statusEnum.STARRED:
        url += '&filters[]=STARRED';
        break;
      case statusEnum.ENDED:
        url += '&filters[]=ENDED';
        break;
      case statusEnum.FAILED:
        url += '&filters[]=FAILED';
        break;
    }

    if (collection.productFilter > -1) {
      url += `&filters[]=product_type:${collection.productFilter}`;
    }

    if (collection.searchQuery) {
      url += `&filters[]=relates_to:${encodeURIComponent(collection.searchQuery)}`;
    }

    if (collection.createdByFilter && collection.createdByFilter != -1) {
      url += `&filters[]=launched_by:${collection.createdByFilter}`;
    }

    if (collection.type === 'all') {
      let start = collection.start || moment().tz(store.state.currentUser.timezone).startOf('day'),
        end = collection.end || moment().tz(store.state.currentUser.timezone).endOf('day');

      if (start !== 'all') url += `&filters[]=statistics_date_range:${start.toISOString()}|${end.toISOString()}`;
    }

    if (collection.relaunchOption === 'Current') {
      url += '&filters[]=current_launch_only';
    }

    if (collection.ignoredCampaignIds.length) {
      url += `&filters[]=ignore_ids:${collection.ignoredCampaignIds.join(',')}`;
    }

    return requestService.get(url)
  }

  getCampaign(campaignId) {
    return requestService.get(hateoas.url('client_campaign_details', { clientId: storage.get('client-hash'), campaignId }));
  }

  getTabData(campaignId, tab) {
    return requestService.get(hateoas.url(tab === 'ad-factory' ? 'client_campaign_ad_factory_link' : `client_campaign_${tab}_tab_data`, { clientId: storage.get('client-hash'), campaignId, tab }));
  }

  getCampaignCategories() {
    return requestService.get(`${hateoas.url('get_eligible_categories')}?v=1`);
  }

  getCampaignEligibleUpsells(collection, campaignId, domainId) {
    let url = `${hateoas.url('get_eligible_campaign_upsells')}?page={page}&limit={limit}`;

    if (collection.searchQuery) url += `&filters[]=relates_to:${encodeURIComponent(collection.searchQuery)}`

    if (domainId) url = `${url}&domain_id=${domainId}`;

    url = url.assignParams({ clientId: storage.get('client-hash'), page: collection.page, limit: collection.limit, campaignId });

    return requestService.get(url)
  }

  relaunchCampaign(campaignId, campaign_length, pad_sales) {
    let payload = { campaign_length, pad_sales };

    return requestService.put(hateoas.url('manually_relaunch_campaign', { clientId: storage.get('client-hash'), campaignId }), payload);
  }

  updateCampaignInfo(campaignId, campaign) {
    let payload = campaignsTransformer.transformCampaign(campaign)

    return requestService.put(hateoas.url('update_campaign', { clientId: storage.get('client-hash'), campaignId }), payload);
  }

  getEligibleProducts(campaignId) {
    return requestService.get(hateoas.url('get_campaign_eligible_products', { clientId: storage.get('client-hash'), campaignId }));
  }

  _getChartData(type, start, end, campaignId, latestRelaunchOnly, isWarehouseChart) {
    let url = hateoas.url(type, { clientId: storage.get('client-hash'), campaignId }),
      filters = [];

    if (start !== 'all') {
      if (isWarehouseChart) filters.push(`to=${end.toISOString()}&from=${start.toISOString()}`);
      else filters.push(`end_date=${end.toISOString()}&start_date=${start.toISOString()}`);
    }

    if (latestRelaunchOnly) filters.push('latest_relaunch_only=1');

    if (filters.length) url = `${url}?${filters.join('&')}`;

    return requestService.get(url);
  }

  getVisitors(start, end, campaignId, collection, latestRelaunchOnly) {
    let routeName = `visitor_aggregation_timeline${campaignId ? '_campaign' : ''}`,
      url = hateoas.url(routeName, { clientId: storage.get('client-hash'), campaignId }),
      filters = [];

    if (start !== 'all') filters.push(`end_date=${end.toISOString()}&start_date=${start.toISOString()}`);
    if (latestRelaunchOnly) filters.push('latest_relaunch_only=1');

    if (collection) {
      if (collection.searchQuery) {
        filters.push(`relates_to=${encodeURIComponent(collection.searchQuery)}`);
      }

      if (collection.productFilter && collection.productFilter > -1) {
        filters.push(`product_type_id=${collection.productFilter}`);
      }

      if (collection.statusFilter && collection.statusFilter !== statusEnum.ALL) {
        filters.push(`filters[]=${collection.statusFilter.toUpperCase()}`);
      }

      if (collection.domainFilter && collection.domainFilter != -1) {
        filters.push(`filters[]=whitelabel_domain:${collection.domainFilter}`);
      }

      if (collection.createdByFilter && collection.createdByFilter != -1) {
        filters.push(`filters[]=launched_by:${collection.createdByFilter}`);
      }

      if (collection.relaunchOption && collection.relaunchOption === 'Current') {
        filters.push('current_launch_only=true');
      }
    }

    if (filters.length) url = `${url}?${filters.join('&')}`;

    return requestService.get(url);
  }

  getGeoVisitors(start, end, campaignId, latestRelaunchOnly) {
    return this._getChartData('visitor_aggregation_geo_campaign', start, end, campaignId, latestRelaunchOnly);
  }

  getHeatmap(start, end, campaignId, latestRelaunchOnly) {
    return this._getChartData('visitor_aggregation_dotw_heatmap_campaign', start, end, campaignId, latestRelaunchOnly);
  }

  getVisitorsByDevice(start, end, campaignId, latestRelaunchOnly) {
    return this._getChartData('visitor_aggregation_device_campaign', start, end, campaignId, latestRelaunchOnly);
  }

  getVisitorReferrals(start, end, campaignId, latestRelaunchOnly) {
    return this._getChartData('visitor_aggregation_referrals_campaign', start, end, campaignId, latestRelaunchOnly);
  }

  getUpsellStats(start, end, campaignId, latestRelaunchOnly) {
    return this._getChartData('get_client_upsell_aggregations', start, end, campaignId, latestRelaunchOnly, true);
  }

  getProductsAggregations(start, end, campaignId, latestRelaunchOnly) {
    return this._getChartData('campaign_relaunch_product_aggregations', start, end, campaignId, latestRelaunchOnly);
  }

  getReferrerAggregations(start, end, campaignId, latestRelaunchOnly) {
    return this._getChartData('visitor_aggregation_utm_groups_design', start, end, campaignId, latestRelaunchOnly);
  }

  getCampaignHistory(campaignId) {
    return requestService.get(hateoas.url('campaign_relaunch_history', { clientId: storage.get('client-hash'), campaignId }))
  }

  getProductTypes() {
    return requestService.get(hateoas.url('get_client_product_types', { clientId: storage.get('client-hash') }));
  }
}

export default new CampaignsApi();